import { LabelType } from 'types/Label'
import { Translation } from 'types/Translation'
import { CreateLabelSchema, EditLabelSchema } from 'validations/LabelSchema'

const defaultValues = {
  name: '',
  nameTranslations: [],
  color: '#000000',
  type: LabelType.USER_DEFINED,
}

const languageCodeSorter = (a: Translation, b: Translation) =>
  (a.languageCode > b.languageCode ? 1 : a.languageCode === b.languageCode ? 0 : -1)

const getSortedNameTranslations = (nameTranslations?: Translation[]) => (
  nameTranslations?.sort(languageCodeSorter)
)

const getValidationSchema = (isEditing: boolean) => (
  isEditing
    ? CreateLabelSchema
    : EditLabelSchema
)

export {
  defaultValues,
  getValidationSchema,
  getSortedNameTranslations,
}
